// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","headerImage":"Header_headerImage___FMYR"};